import React from "react";
import patientIcon from "../../assets/images/Patient.svg";
import userIcon from "../../assets/images/user_color.svg";
import tokenIcon from "../../assets/images/TokenGenerator.svg";
import { Popover } from "antd";

const TechnicianPatientCard = (props) => {
  const {
    data,
    draggableStatus,
    popupContent,
    clicked,
    handleClickChange,
    viewtype,
  } = props;
  return (
    <>
      <div class="TechnicianPatientCard">
        <div class="row pl-3 pt-2">
          <div class="col-8">
            <div class="row">
              <img
                alt=""
                src={patientIcon}
                width={35}
                height={20}
                class="patientIcon"
              />
              <span class="Patientname">{data.name}</span>
            </div>
            <div class="row pl-2 pt-2">
              <img
                alt=""
                src={userIcon}
                width={20}
                height={20}
                className="uidIcon"
              />
              <span class="PatientUid">UID: {data.umr ? data.umr : "--"}</span>
            </div>
            <div class="row pl-2 pt-2">
              <img alt="" src={tokenIcon} width={20} height={25} />
              <span class="pl-1">Token: </span>
            </div>
          </div>
          <div class="col-4">
            <span class="ml-4 time">{data.waitingTAT}</span>
            <div className="statusDiv mt-1">
              <span class="status">IN</span>
            </div>
            <div className="col-4 ml-3">
              {viewtype == "doctor" ? (
                <p>
                  <img
                    src="/assets/images/icons/more-icon.png"
                    alt="more"
                    srcSet=""
                    draggable={draggableStatus}
                    width="15px"
                  />
                </p>
              ) : (
                <p>
                  <Popover
                    content={popupContent}
                    trigger="click"
                    visible={clicked}
                    onVisibleChange={handleClickChange}
                  >
                    <img
                      src="/assets/images/icons/more-icon.png"
                      alt="more"
                      srcSet=""
                      draggable={draggableStatus}
                      width="15px"
                    />
                  </Popover>
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TechnicianPatientCard;
